// extracted by mini-css-extract-plugin
module.exports = {"container":"_1jX3iZY69nqnKPQcMcwLcj","visible":"_1Mq2o3wZy_3HlHMiJTHheO","button":"ix-QPscQTt0I8G2_Qg-Cn","closeIcon":"_25bax8SqUxtM8R92GtmAMb"};